<template>
<div>
    <Row >
        
    <Col span="12">
    <Form ref="form" :model="forms" :rules="formRules" :label-width="120">
        <form-header name="修改密码" label="基本信息"></form-header>

        <FormItem label="登录密码" prop="password">
            <Input v-model="forms.password"  placeholder="请输入登录密码"></Input>
        </FormItem>
       <FormItem label="新的密码" prop="new_password" >
            <Input v-model="forms.new_password" placeholder="请输入新的密码"></Input>
        </FormItem>
        <FormItem label="确认密码" prop="new_password1" >
            <Input v-model="forms.new_password1" placeholder="请输入确认密码"></Input>
        </FormItem>
        <button-box>
            <button-sub @click="handleSubmit" :loading="sloading"></button-sub>
            <button-back></button-back>
        </button-box>
    </Form>
    </Col>
    </Row>
    
</div>
</template>
<script>
import baseView from '@/views/components/base/baseView.vue'
    export default {
        extends: baseView,
        components: {
        },
        data () {
            return {
                index: 1,
                sloading: false,
                action: 'add',
                mname: 'user',
                kv: '',
                url: {},
                forms: {
                    password: '',
                    new_password: '',
                    new_password1: '',
                },
                formRules: {
                }
            }
        },
        created () {
        },
        methods: {
            
           handleSubmit () {
                console.log('handleSubmit forms', this.forms);
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        // 修改密码
                        if(this.forms.new_password !== this.forms.new_password1) {
                            $utils.toast.warn('两次输入密码不一致');
                            return
                        }
                        let q = this.forms
                        $utils.api.load('authUpPassword', q, 'post', {toast:true}).then((res) => {
                            //
                        })
                    }
                })
            }
        }
    }
</script>
<style lang="less" scoped>
</style>

